<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteCompany" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting" :isDeleteValidate="isDeleteValidate"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Code:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="company.code" :readonly="identifier != null"/>
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Name:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="100" placeholder="Name" v-model="company.name" />
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Currency:</label>
									</div>

									<div class="col-md-6">
										<Dropdown :options="currencies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear placeholder="-- Please Select --" v-model="company.currency.identifier">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCurrencyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCurrencyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3">
										<label class="col-form-label-title">Legal Parent:</label>
									</div>
												
									<div class="col-md-6">
										<Dropdown :options="companies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear :placeholder="isCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isCompanyLoading" v-model="company.companyId">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCompanyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCompanyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
								</div>
													
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Status:</label>
									</div>
												
									<div class="col-md-6">
										<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="company.isClosed" />
									</div>
								</div>
											
                                <div class="row mb-4">
									<div class="col-md-3">
										<label class="col-form-label-title">Is Virtual: </label>
									</div>
												
									<div class="col-md-6 pt-1">
										<Checkbox v-model="company.isVirtual" :binary="true" />
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3"></div>
												
									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.company.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
													
										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>

</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router"
	import store from "@/store";
	import companyApi from "@/api/company-api"
	import currencyApi from "@/api/currency-api";
	import statusMixin from "@/mixin/status"
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	import useVuelidate from "@vuelidate/core"
	import { required } from "@vuelidate/validators"
	
	export default defineComponent({
		mixins: [statusMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				company: {code: '', name: '', companyId: null as any, currency: {identifier: null as any, name: null as any}, isVirtual: false, isClosed: false},
				currentCompanyCompanyId: null as any,
				companies: [] as any[],
				currencies: [] as any[],
				isPageLoading: false,
				isLoading: false,
				isCompanyLoading: false,
				isDeleting: false,
				isDeleteValidate: false
			}
		},
		watch: {
			filterLegalGroupId(newValue: any) {					
				this.isCompanyLoading = true;
				companyApi.companyList({}, this.filterLegalGroupId)
					.then(response => {
						this.company.companyId = null;
						this.companies = response.data.listSet;
						this.isCompanyLoading = false;
					})
					.catch(error => {
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						this.isCompanyLoading = false;
					})
			}
		},
		computed: {
			filterLegalGroupId() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
			},
			filterLegalGroupCode() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.code : null);
			},
		},
		mounted: function() {
			if (this.pageError == '') {
				this.isPageLoading = true;
				
				let r1 = currencyApi.currencyList({});

				let r2 = companyApi.companyList({}, this.filterLegalGroupId);

				let r3 = null;

				let r4 = null;

				if (this.identifier != null) {
					r3 = companyApi.companyView(this.identifier)
						.then(response => {
							this.company = response.data.company;	
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						});
					
					r4 = r3.then(() => {
							return companyApi.companyDeleteValidate({company:{identifier: this.identifier, code: this.company.code}})
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						});
				}

				else {
					this.company.currency = {identifier: 109, name: "Malaysian Ringgit"};
				}
				
				Promise.all([r1, r2, r3, r4]).then((values: any) => {
					if (values != null) {
						for (var i = 0; i < values.length; i++) {
							if (values[i] != null) {
								if (values[i].success) {
									if (values[i].data != null) {
										if (i == 0) {
											this.currencies = values[i].data.listSet;
										}

										else if (i == 1) {
											this.companies = values[i].data.listSet;
											var index = this.companies.findIndex((company: any)=> {
												return company.identifier == this.identifier;
											});
											this.companies.splice(index, 1);
										}
										
										else if (i == 2) {
											this.company = values[i].data.company;

											this.currentCompanyCompanyId = this.company.companyId;
											if (this.company.currency == null) {
												this.company.currency = {identifier: null, name: null};
											}

											var companyIndex = this.companies.findIndex((company: any) => {
												return company.identifier == this.company.companyId;
											})
											if (companyIndex == -1) {
												this.company.companyId = null;
											}

											var currencyIndex = this.currencies.findIndex((currency: any) => {
												return currency.identifier == this.company.currency.identifier;
											})
											if (currencyIndex == -1) {
												this.company.currency = {identifier: null, name: null};
											}
										}

										else if (i == 3) {
											this.isDeleteValidate = values[i].data;
											
										}
									}
								}
							}
						}
					}
					this.isPageLoading = false;
				})
				.catch(error => {
					this.isPageLoading = false;
					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
				})
			}
		},
		methods: {
			filterCompanyCodeByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].code;
				}
				return null;
			},
			filterCompanyNameByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].name;
				}
				return null;
			},
			filterCurrencyByDefaultCode: function (code: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.code == code) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return this.company.currency.identifier = currencies[0].identifier;
				}
			},
			filterCurrencyCodeByValue: function (value: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.identifier == value) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return currencies[0].code;
				}
				return null;
			},
			filterCurrencyNameByValue: function (value: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.identifier == value) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return currencies[0].name;
				}
				return null;
			},
			save() {
				this.isLoading = true;
				companyApi.companySave({
						company: this.company
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push("/admin/company");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				companyApi.companyUpdate({
					company: this.company
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push("/admin/company");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			deleteCompany() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this company?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						companyApi.companyDelete({
								company: this.company
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/company");
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push("/admin/company");
			}
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				company : {
					code: {
						required
					},
					name: {
						required
					},
					currency: {
						identifier: {
							required
						}
					},
					isClosed: {
						required
					},
				}
			}
		}
	});
</script>
